import React, { useState } from "react";
import LessonBlockEditorPanel from "../../lesson/LessonBlockEditorPanel";
import { ExplanationBlockList } from "./ExplanationBlockList";

export default function BlocksContainerEditor({
                                                  value = { blocks: [] },
                                                  onChange,
                                                  courseId,
                                                  title = "Blocks",
                                              }) {

    const [selectedBlockId, setSelectedBlockId] = useState(null);

    const blocks = value.blocks ?? [];

    const selectedBlock =
        blocks.find(b => b.id === selectedBlockId) ?? null;

    const updateBlocks = (nextBlocks) => {

        onChange({
            ...value,
            blocks: nextBlocks,
        });

    };

    return (

        <div className="space-y-4 mt-6">

            <h3 className="font-semibold">
                {title}
            </h3>

            <div className="grid grid-cols-2 gap-4">

                <ExplanationBlockList
                    blocks={blocks}
                    selectedBlockId={selectedBlockId}
                    onSelect={setSelectedBlockId}
                    onChange={(nextBlocks, newlySelectedId) => {

                        updateBlocks(nextBlocks);

                        if (newlySelectedId) {
                            setSelectedBlockId(newlySelectedId);
                        }

                    }}
                    onDelete={(blockId) => {

                        const nextBlocks =
                            blocks.filter(
                                b => b.id !== blockId
                            );

                        if (selectedBlockId === blockId) {
                            setSelectedBlockId(null);
                        }

                        updateBlocks(nextBlocks);

                    }}
                />

                <LessonBlockEditorPanel
                    fragmentId="blocks-container"
                    courseId={courseId}
                    block={selectedBlock}
                    onChange={(patch) => {

                        updateBlocks(

                            blocks.map(block =>
                                block.id === selectedBlockId
                                    ? {
                                        ...block,
                                        ...patch,
                                    }
                                    : block
                            )

                        );

                    }}
                />

            </div>

        </div>

    );

}